import { transformknowledgeBase, containsWord } from "./knowledgeBase";

import {
    convertUTCToLocalTime, convertGender, convertCity, convertOccupation,
    convertAge, convertModelName, convertModelMenu, findItemByProperty, arraysAreEqual, convertBytesToMB,
    convertCategorysToLocalFormat, convertPermissionsToTableData, convertTableDataToPermissions,
    convertKnowledgeBaseConfigToOptions, mergeWithIsActive, getCurrentFormattedTime,
    compareVersions, incrementVersion, getCurrentTodayFormattedTime, getStartOfWeekDate,
    getStartOfMonth, getStartOfToday, transformCategorizeData, componentDocumentIcons,
    getMonthStartEndDates, getWeeklyStartEndDates,
} from './adminConverter'

import {
  findConversationId,
  extractConversationIdAndId,
  getSingleConversationFromAllChatData,
  getMessagesFromAllChatData,
  isMessagesEmpty,
  uniqueByImageId,
  addKeyWithExtrainfoIdAndScore,
  filterSearchInfo,
} from "./operateChatData";

import {
  handleReponseStreamChatData,
  findOverlap,
  extractFirstLink,
  extractFirstImageContainer,
  handleStreamDataTruncation,
  handleConvertHistoryRecordCiteText,
} from "./parseResponseData";

import {
  getUrlVars,
  getOriginWithExplicitPort,
  isDevelopment,
  detectDevice,
  isPhoneType,
} from "./qywxLogin";

import { scrollToBottom, isDivScrolledToBottom } from "./scrollContent";

import {
    generateRandomId, createNewMessage, createNewConversation,
    generateOptionsByChatData, transformDateList, formatResponseConversationsDataToLocal,
    formatResponseMessagesDataToLocal, findNextElementByMessageId, removeHtmlTags,
    formatCollectMessageDataToLocal, searchResultTemplate, transformMaterialQueryImage,
    transformMaterialResponseImage,
} from './formatChatData'

import {
  getTodaysVisitors,
  getThisWeeksVisitors,
  getLast7DaysNewUsers,
} from "./formatAdminInfo";

import {
  fetchWithCookieRefresh,
  createController,
  handleResponseError,
} from "./fetchUtils";

import {
  chatTypeIcons,
  chatTypeSidebarIcons,
  chatTypeOptionsSortByWeight,
  getTopActiveModelsByWeight,
} from "./chatTypeIcons";

import {
  experienceIcons,
  checkExperience,
  getLevelFromExperience,
} from "./experience";

import {
    transformImageSpecifications,
} from './detailConverter'

export {
    transformknowledgeBase, containsWord, convertUTCToLocalTime,
    convertGender, convertCity, convertOccupation,
    convertAge, convertModelName, convertModelMenu, findItemByProperty, arraysAreEqual, convertBytesToMB,
    convertCategorysToLocalFormat, convertPermissionsToTableData, convertTableDataToPermissions,
    convertKnowledgeBaseConfigToOptions, mergeWithIsActive, getCurrentFormattedTime,
    compareVersions, incrementVersion, getCurrentTodayFormattedTime, getStartOfWeekDate,
    getStartOfMonth, getStartOfToday, transformCategorizeData, componentDocumentIcons,
    getMonthStartEndDates, getWeeklyStartEndDates,

    findConversationId, extractConversationIdAndId, getSingleConversationFromAllChatData,
    getMessagesFromAllChatData, isMessagesEmpty, uniqueByImageId, addKeyWithExtrainfoIdAndScore,
    filterSearchInfo,

    handleReponseStreamChatData, findOverlap, extractFirstLink,
    extractFirstImageContainer, handleStreamDataTruncation, handleConvertHistoryRecordCiteText,

    getUrlVars, getOriginWithExplicitPort, isDevelopment,
    detectDevice, isPhoneType,

    scrollToBottom, isDivScrolledToBottom,

    generateRandomId, createNewMessage, createNewConversation,
    generateOptionsByChatData, transformDateList, formatResponseConversationsDataToLocal,
    formatResponseMessagesDataToLocal, removeHtmlTags, formatCollectMessageDataToLocal,
    searchResultTemplate, transformMaterialQueryImage, transformMaterialResponseImage,

    getTodaysVisitors, getThisWeeksVisitors, getLast7DaysNewUsers,

    fetchWithCookieRefresh, createController, handleResponseError,

    chatTypeIcons, chatTypeSidebarIcons,
    chatTypeOptionsSortByWeight,
    getTopActiveModelsByWeight,

    experienceIcons, checkExperience, getLevelFromExperience,

    transformImageSpecifications,
}
